import { Box } from '@skin-seoul/design-system';
import type { Currency, RecommendedProduct } from '@skin-seoul/service';
import AIChoiceProductCarousel from './AIChoiceProductCarousel';
import AIChoiceProductsScroll from './AIChoiceProductsScroll';
import { ProductEmpty } from './ProductEmpty';
type AIChoiceSectionProps = {
  isFetching: boolean;
  selectedRecommendations?: RecommendedProduct[];
  selectedProductId?: number;
  currency: Currency;
  onProductClick: (productId: number, productLink: string) => void;
};
const AIChoiceSection = ({
  isFetching,
  selectedRecommendations,
  selectedProductId,
  currency,
  onProductClick
}: AIChoiceSectionProps) => {
  if (isFetching) {
    return <>
        <Box width="100%" overflow="hidden" display={{
        base: 'block',
        desktop: 'none'
      }}>
          <AIChoiceProductsScroll.Skeleton />
        </Box>
        <Box width="100%" display={{
        base: 'none',
        desktop: 'block'
      }}>
          <AIChoiceProductCarousel.Skeleton />
        </Box>
      </>;
  }
  const hasRecommendations = selectedRecommendations && selectedRecommendations.length > 0;
  if (!hasRecommendations) {
    return <Box width="100%" height="100%">
        <ProductEmpty />
      </Box>;
  }
  return <>
      <Box width="100%" overflow="hidden" display={{
      base: 'block',
      desktop: 'none'
    }} data-sentry-element="Box" data-sentry-source-file="AIChoiceSection.tsx">
        <AIChoiceProductsScroll products={selectedRecommendations} selectedProductId={selectedProductId} onProductClick={onProductClick} data-sentry-element="AIChoiceProductsScroll" data-sentry-source-file="AIChoiceSection.tsx" />
      </Box>
      <Box width="100%" display={{
      base: 'none',
      desktop: 'block'
    }} data-sentry-element="Box" data-sentry-source-file="AIChoiceSection.tsx">
        <AIChoiceProductCarousel products={selectedRecommendations} data-sentry-element="AIChoiceProductCarousel" data-sentry-source-file="AIChoiceSection.tsx" />
      </Box>
    </>;
};
export default AIChoiceSection;